"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const lodash_1 = __importDefault(require("lodash"));
const PageComponent_1 = __importDefault(require("./PageComponent"));
const pathHelpers_1 = require("./utils/pathHelpers");
const PageContexts_1 = require("./Contexts/PageContexts");
const GridWrapper_1 = __importDefault(require("./GridWrapper"));
// Main renderer for the form elements
// Takes template and goes through in order to generate the form
const PageRenderer = props => {
    const { template, controlPathPrefix, values, forceOneColumn, forceOneLine, disableStreetView, isDesktopCard, noMargin, hidden } = props;
    // the ordre management array is just the order of the components and whether or not they should be "contained"
    // It only when the template changes, so we should memoize it
    const { controlMap } = (0, PageContexts_1.useControlProvider)();
    const formTemplateRendererWithProp = (0, react_1.useCallback)((component, sectionKey, value, values, displayMap, defaultDateTimeFormat, forceOneLine, hidden) => {
        // Rendered for every component that is not in a group, and then once per group
        const controlPath = (0, pathHelpers_1.formattedPath)(sectionKey, controlPathPrefix);
        // Page elements. Component is form element definition from gen5lib
        return (react_1.default.createElement(PageComponent_1.default, { forceOneLine: forceOneLine, defaultDateTimeFormat: defaultDateTimeFormat, displayMap: displayMap, component: component, controlPath: controlPath, value: value, values: values, hidden: hidden }));
    }, [controlPathPrefix]);
    const elements = (0, react_1.useMemo)(() => {
        const e = Object.keys(template.elements).map(ele => {
            return {
                key: ele,
                value: template.elements[ele].row * template.columns + template.elements[ele].column, //Sort elements in order to display
            };
        });
        return e.sort((a, b) => a.value - b.value);
    }, [template]);
    return values ? (react_1.default.createElement(controlMap.GridWrapper, { columns: forceOneLine ? 1 : template.columns, isOneElement: elements.length === 1, noMargin: noMargin }, elements.map(k => {
        const ele = template.elements[k.key];
        const key = (0, pathHelpers_1.formattedPath)(k.key, controlPathPrefix);
        const value = lodash_1.default.get(values, key);
        return ele.component.type === 'streetView' && disableStreetView ? (react_1.default.createElement(react_1.default.Fragment, null)) : (react_1.default.createElement(PageContexts_1.VisibilityProvider, { key: key },
            react_1.default.createElement(GridWrapper_1.default, Object.assign({}, {
                key,
                controlMap,
                forceOneColumn,
                componentType: ele.component.type,
                columnSpan: ele.columnSpan,
                columns: template.columns,
                allowDynamicSizing: template.allowDynamicSizing,
                isOneElement: elements.length === 1,
                isDesktopCard,
                hidden
            }),
                react_1.default.createElement(controlMap.RootWrapper, null, formTemplateRendererWithProp(ele.component, k.key, value, values, ele.component.displayOptions, props.defaultDateTimeFormat, forceOneLine, hidden)))));
    }))) : (react_1.default.createElement(react_1.default.Fragment, null));
};
exports.default = react_1.default.memo(PageRenderer);
